import { Injectable } from '@angular/core';
import { MFAToken } from 'app.services/login/components/mfa/mfa.types/mfa.token';
import { BehaviorSubject } from "rxjs";
import { LogManager } from "../../log/services/log.manager";
import { LogCat } from "../../log/services/log.manager.categories";
import * as cred from "./service.auth.proxy";


/*
	credentials cache.
	notice this is not a UserContext - this container is used solely for credentials storing.
	set as a separate class to be easily injected (and overridden if needed)
	*/
@Injectable({ providedIn: 'root' })
  export class CredentialsCache {


	public tokenUpdates = new BehaviorSubject<cred.IAccessToken>(null);

	public mToken:cred.IAccessToken = null;

	public mMFAToken: MFAToken = null;

	// this is an indication that we were already logged in once. due to angular limitations we need
	// to reload all the providers and this will give us this indication
	private prevLoginExists:boolean = false;
	private readonly sessionStorageKey: string = 'CredentialsCache.Token';

	isOrWasTokenSet(){
		return this.isTokenSet() || this.prevLoginExists;
	}

	isTokenSet():boolean {
		return null != this.mToken;
	}

	get accessToken():string {
		this.throwIfTokenInvalid();
		return this.mToken.accessToken;
	}

	get refreshToken(): string {
		this.throwIfTokenInvalid();
		return this.mToken.refreshToken;
	}

	public tokenNotifications(){
		return this.tokenUpdates.asObservable();
	}

	public throwIfTokenInvalid():void {
		LogManager.debug(LogCat.User.Credentials, "throwIfTokenInvalid started");
		if (!this.isTokenSet()) {
			LogManager.error(LogCat.User.Credentials, "Token not set - about to throw exception");
			throw new Error("token not set");
		}
	}

	public saveToSessionStorage(): void {
		sessionStorage[this.sessionStorageKey] = JSON.stringify(this.mToken);
	}

	public clearSessionStorage(): void {
		sessionStorage.removeItem(this.sessionStorageKey);
	}

	public getFromSessionStorage(): cred.IAccessToken {
		return JSON.parse(sessionStorage.getItem(this.sessionStorageKey));
	}

	set token(t:cred.IAccessToken) {
		this.prevLoginExists=true;
		this.mToken = t;
		this.tokenUpdates.next(t);
	}

	set MFAToken(t: any) {
		this.mMFAToken = t;
	}

	get MFAToken():string {
		return this.mMFAToken.Token;
	}
}
